import React from 'react';
import ReactTooltip from 'react-tooltip';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../../../../../redux/gitHubIntegration/actions.gitHubIntegration';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import withClickOutsideOnOverlay from '../../../../../hoc/withClickOutsideOnOverlay';
import gitHubIcon from '../../../../../assets/images/github/github-black.svg';
import PopupWrapper from '../../../../components/Popup/PopupWrapper';
import PopupBody from '../../../../components/Popup/PopupBody';
import ComboBox from '../../../../components/ComboBox/ComboBox';
import PopupButtons from '../../../../components/Popup/PopupButtons';
import { Loader } from '../../../../components/Loader/Loader';
import PopupButton from '../../../../components/Popup/PopupButton';
import PopupCancelButton from '../../../../components/Popup/PopupCancelButton';
import FolderIcon from '../../../../icons/FolderIcon';
import FileIcon from '../../../../icons/FileIcon';
import { getFilesAndFoldersByPath } from '../../../../../services/mini/gitHelpers';
import { routeInfo } from '../../../../../routeInfo';
import history from '../../../../../history';
import {Environment} from '../../../../../const/environment';

class AddGitHubRepositoryForm extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            currentOrganizationId: 'personal',
            currentRepositoryId: 'empty',
            currentBranchId: 'empty',
            folderPath: '',
            isAdding: false,
            ciCdMode: props.environment === Environment.Staging ? false : true,
        };

        this._isMounted = true;
    }

    componentDidMount() {
        this.props.getOrganizationsByUser();
        this.props.getRepositoriesByUser();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    cancel = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    validateRepositoryUrl = ({ repoUrl }) => {
        if (!repoUrl) {
            return 'Enter url';
        }

        return null;
    }

    validateGithubUser = ({ githubUser }) => {
        if (!githubUser) {
            return 'Enter GitHub user';
        }

        return null;
    }

    changeOrganization = ({ id }) => {
        const { resetBranchesAndFilesAfterSwithcingRepos } = this.props;
        const { currentOrganizationId } = this.state;

        if (id === currentOrganizationId) return;

        resetBranchesAndFilesAfterSwithcingRepos();

        this.setState({
            currentOrganizationId: id,
            currentRepositoryId: 'empty',
            currentBranchId: null,
            folderPath: ''
        });
    }

    changeRepository = ({ id, fullName }) => {
        this.setState({
            currentRepositoryId: id,
            currentRepositoryFullName: fullName,
            folderPath: ''
        });
        this.setState({ currentBranchId: 'empty' }, () => {
            this.props.getBranchesByRepository({
                repo: fullName
            });
        });
    }

    changeBranch = ({ id, name, commit }) => {
        this.setState({
            currentBranchId: id,
            currentBranchName: name,
            folderPath: ''
        }, () => {
            this.props.getFilesByBranch({
                projectId: this.props.projectId,
                repo: this.state.currentRepositoryFullName,
                commitSha: commit.sha,
                branch: name
            });
        });
    }

    addRepoForCiCd = () => {
        const {
            project,
            addRepoForCiCd,
            repositories,
            environment
        } = this.props;

        const {
            folderPath,
            currentBranchName,
            currentRepositoryFullName
        } = this.state;

        addRepoForCiCd({
            project,
            repoUrl: currentRepositoryFullName,
            folder: folderPath,
            branch: currentBranchName,
            environment
        }).then(() => {
            if (!this._isMounted) return;
            this.setState({ isAdding: false });
            this.cancel();
        }, () => {
            if (!this._isMounted) return;
            this.setState({ isAdding: false });
        });
    }

    addFiles = () => {
        const {
            project,
            addFilesToProject,
            repositories
        } = this.props;

        const {
            folderPath,
            currentBranchName,
            currentRepositoryFullName
        } = this.state;

        const filesToAdd = this.getDisplayedFiles().filter(file => file.type === 'blob');
        const curRepo = _.find(repositories, { fullName: currentRepositoryFullName });

        this.setState({ isAdding: true });

        addFilesToProject({
            project,
            repoUrl: currentRepositoryFullName,
            folder: folderPath,
            branch: currentBranchName,
            repoPermissions: curRepo.permissions,
            files: filesToAdd
        }).then(() => {
            if (!this._isMounted) return;
            this.setState({ isAdding: false });
            this.cancel();
        }, () => {
            if (!this._isMounted) return;
            this.setState({ isAdding: false });
        });
    }

    goToProfilePage = () => {
        history.push(routeInfo.profile.url());
    }

    addRepoWithoutFiles = () => {
        const {
            project,
            addRepoWithoutFilesToProject,
            repositories
        } = this.props;

        const {
            folderPath,
            currentBranchName,
            currentRepositoryFullName
        } = this.state;

        this.setState({ isAdding: true });

        const curRepo = _.find(repositories, { fullName: currentRepositoryFullName });

        addRepoWithoutFilesToProject({
            project,
            repoUrl: currentRepositoryFullName,
            folder: folderPath,
            branch: currentBranchName,
            repoPermissions: curRepo.permissions,
        }).then(() => {
            if (!this._isMounted) return;
            this.setState({ isAdding: false });
            this.cancel();
        }, () => {
            if (!this._isMounted) return;
            this.setState({ isAdding: false });
        });
    }

    selectFolder = (folder) => {
        this.setState({ folderPath: `${folder}/` });
    }

    goToUpLevel = () => {
        let { folderPath } = this.state;
        let folders = folderPath.split('/');
        if (folders.length > 1) {
            folderPath = folderPath.replace('/', '');
            folderPath = folderPath.replace(folders[folders.length - 2], '');
        }
        this.setState({ folderPath });
    }

    getDisplayedFiles = () => {
        const { folderPath } = this.state;
        const { files } = this.props;

        return getFilesAndFoldersByPath(files, folderPath);
    }

    turnOffCiCdMode = () => {
        this.setState({ ciCdMode: false });
    }

    turnOnCiCdMode = () => {
        this.setState({ ciCdMode: true });
    }

    render() {
        const { currentOrganizationId, currentRepositoryId, currentBranchId, folderPath, isAdding, ciCdMode } = this.state;
        const { organizations, branches, environment } = this.props;
        let { repositories } = this.props;
        const files = this.getDisplayedFiles();
        const hideAddFilesBtn = branches?.length === 0 || (branches?.length !== 0 && files?.length === 0);

        const isStage = environment === Environment.Staging;

        if (repositories && organizations && organizations.length > 1) {

            const organizationNames = organizations.map(org => org.login);

            repositories = repositories.filter((repo) => {
                if (currentOrganizationId === 'personal') {
                    return organizationNames.indexOf(repo.owner.login) === -1;
                }
                return +repo.owner.id === +currentOrganizationId;
            });
        }

        return <PopupWrapper className="add-github-repository-form" >
            <div className="add-github-repository-form__tabs">
                <div className={`add-github-repository-form__tab ${!ciCdMode && 'selected'} ${!isStage && 'disabled-with-cursor'}`} onClick={!isStage ? undefined : this.turnOffCiCdMode}><img src={gitHubIcon} />
                    GitHub repository URL
                    <i className="icon icon-alan-help-sign add-github-repository-form__info-icon"
                        data-tip="Select a GitHub organization and repository to store voice scripts."
                        data-for="githubPushPullTooltip"
                        data-class="tutor-light-tooltip tutor-no-arrow-tooltip" />
                </div>
                <div className={`add-github-repository-form__tab ${ciCdMode && 'selected'}`} onClick={this.turnOnCiCdMode}><img src={gitHubIcon} />
                    GitHub CI/CD
                    <i className="icon icon-alan-help-sign add-github-repository-form__info-icon"
                        data-tip="Select a GitHub organization and repository to which your team merges voice script changes. Updates made to the scripts will be loaded in Alan AI Studio automatically."
                        data-for="githubCiCdTooltip"
                        data-class="tutor-light-tooltip tutor-no-arrow-tooltip cicd-tooltip" />
                </div>
                <i className="icon icon-alan-remove-fat" onMouseUp={this.cancel} />
                <ReactTooltip id="githubCiCdTooltip" />
                <ReactTooltip id="githubPushPullTooltip" />
            </div>
            <PopupBody>
                <div className="add-github-repository-form__body">
                    {
                        (_.isArray(repositories) && _.isArray(organizations)) ?
                            <React.Fragment>
                                {(organizations.length > 0 && repositories.length > 0) ?
                                    <React.Fragment>
                                        <div className="add-github-repository-form__selectors">
                                            {(organizations?.length > 0 && currentOrganizationId) &&
                                                <div className="add-github-repository-form__col">
                                                    <div className="add-github-repository-form__col-title">
                                                        Select organization
                                                    </div>
                                                    <ComboBox
                                                        values={organizations}
                                                        valueKey="id"
                                                        valueName="login"
                                                        width="142px"
                                                        noItemsFoundMessage="No organizations"
                                                        showListForOneItem={true}
                                                        selectedValueId={currentOrganizationId}
                                                        onValueSelect={this.changeOrganization}
                                                        renderItem={(organizationItem) => {
                                                            return <div className="add-github-repository-form__list-item">
                                                                {organizationItem.login}
                                                            </div>;
                                                        }} />
                                                </div>
                                            }
                                            {(repositories?.length > 0 && currentRepositoryId) &&
                                                <div className="add-github-repository-form__col">
                                                    <div className="add-github-repository-form__col-title">
                                                        Select repository
                                                    </div>
                                                    <ComboBox
                                                        values={repositories}
                                                        valueKey="id"
                                                        valueName="name"
                                                        width="142px"
                                                        withSearch={true}
                                                        noItemsFoundMessage="No repositories"
                                                        showListForOneItem={true}
                                                        selectedValueId={currentRepositoryId}
                                                        onValueSelect={this.changeRepository}
                                                        renderItem={(repositoryItem) => {
                                                            return <div className="add-github-repository-form__list-item">
                                                                {repositoryItem.name}
                                                            </div>;
                                                        }} />
                                                </div>
                                            }
                                            {(branches?.length > 0 && currentBranchId) &&
                                                <div className="add-github-repository-form__col">
                                                    <div className="add-github-repository-form__col-title">
                                                        Select branch
                                                    </div>
                                                    <ComboBox
                                                        values={branches}
                                                        valueKey="id"
                                                        valueName="name"
                                                        width="142px"
                                                        showListForOneItem={true}
                                                        selectedValueId={currentBranchId}
                                                        onValueSelect={this.changeBranch}
                                                        renderItem={(branchItem) => {
                                                            return <div className="add-github-repository-form__list-item">
                                                                {branchItem.name}
                                                            </div>;
                                                        }} />
                                                </div>
                                            }
                                        </div>
                                        <div className="add-github-repository-form__info">
                                            <i className="icon icon-alan-unrecognized-sign" />
                                            If you don't see your organization/repository in the lists above, go to the <a onClick={this.goToProfilePage}>Profile page</a>, revoke access to the Alan AI application for your GitHub account and re-sync it again.
                                        </div>

                                        <div className="add-github-repository-form__files">
                                            <div className="add-github-repository-form__files-title">
                                                Select folder or add files from the root level
                                            </div>

                                            <div className="add-github-repository-form__file-list">
                                                {(files && files.length && folderPath !== '') ? <div
                                                    className="add-github-repository-form__file-list-item back"
                                                    onClick={this.goToUpLevel}>..</div> : <React.Fragment></React.Fragment>}
                                                {(currentBranchId && files && files.length > 0) ?
                                                    files.map(({ path, type, nameToDisplay }) => {
                                                        const isFolder = type !== 'blob';
                                                        return <div
                                                            key={path}
                                                            className={`add-github-repository-form__file-list-item ${isFolder && 'folder'}`}
                                                            onClick={isFolder ? () => {
                                                                this.selectFolder(path);
                                                            } : undefined}>
                                                            {isFolder ? <FolderIcon /> : <FileIcon />}
                                                            {nameToDisplay}
                                                        </div>;
                                                    }) :
                                                    <div>There are no files that can be added to this project</div>
                                                }
                                            </div>
                                        </div>
                                    </React.Fragment> :
                                    <div>You don't have repositories to add. Go to <a href="https://github.com" target="_blank" rel="noreferrer">GitHub</a> to create a repository to start</div>}
                            </React.Fragment> :
                            <Loader theme="dark" size="medium" center={true} />
                    }
                </div>
                <PopupButtons>
                    <PopupCancelButton label="Close" action={this.cancel} />
                    {!hideAddFilesBtn ?
                        <PopupButton
                            label="Add files"
                            className={`${!(files?.length > 0) && 'disabled'} ${isAdding && 'btn-loader'}`}
                            action={ciCdMode ? this.addRepoForCiCd : this.addFiles} /> :
                        <PopupButton
                            label="Add repo"
                            className={`${isAdding && 'btn-loader'}`}
                            action={ciCdMode ? this.addRepoForCiCd : this.addRepoWithoutFiles} />
                    }
                </PopupButtons>
            </PopupBody>
        </PopupWrapper>;
    }
}

function mapStateToProps({ gitHubIntegration }) {
    return {
        githubLogin: gitHubIntegration.githubLogin,
        repositories: gitHubIntegration.repositories,
        organizations: gitHubIntegration.organizations,
        branches: gitHubIntegration.branches,
        files: gitHubIntegration.files,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getBranchesByRepository: (param) => asyncDispatch(actions.getBranchesByRepository, dispatch, param),
        getFilesByBranch: (param) => asyncDispatch(actions.getFilesByBranch, dispatch, param),
        addFilesToProject: (param) => asyncDispatch(actions.addFilesToProject, dispatch, param),
        addRepoForCiCd: (param) => asyncDispatch(actions.addRepoForCiCd, dispatch, param),
        addRepoWithoutFilesToProject: (param) => asyncDispatch(actions.addRepoWithoutFilesToProject, dispatch, param),
        resetBranchesAndFilesAfterSwithcingRepos: (param) => asyncDispatch(actions.resetBranchesAndFilesAfterSwithcingRepos, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withClickOutsideOnOverlay(AddGitHubRepositoryForm, ['combo-box_list opened']));